import React from "react";
import { cn } from "@/lib/utils";

export function LogoMark({ className }) {
  return (
    <svg viewBox="0 0 48 48" className={cn("h-8 w-8", className)} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect width="48" height="48" rx="12" fill="hsl(var(--primary))" />
      <path d="M15 12h11.5c4.4 0 7.5 2.4 7.5 6.3 0 2.6-1.4 4.5-3.6 5.3 2.7.7 4.4 2.8 4.4 5.8 0 4.2-3.3 6.6-8 6.6H15V12Z"
        fill="white" fillOpacity="0.16" />
      <circle cx="18.5" cy="30" r="3.2" fill="white" />
      <circle cx="31" cy="18" r="3.2" fill="#00C4FF" />
      <path d="M20.5 27.8 29 20.2" stroke="white" strokeWidth="2.1" strokeLinecap="round" />
      <path d="M15 12h11.5c4.4 0 7.5 2.4 7.5 6.3M15 36h8.8c4.7 0 8-2.4 8-6.6"
        stroke="white" strokeWidth="2.6" strokeLinecap="round" fill="none" />
    </svg>
  );
}

export function Logo({ className, textClassName, showText = true, mono = false }) {
  return (
    <div className={cn("flex items-center gap-2.5", className)}>
      <LogoMark />
      {showText && (
        <span className={cn("font-heading text-xl font-extrabold tracking-tight text-foreground", textClassName)}>
          Blue<span className={mono ? "" : "text-primary"}>connect</span>
        </span>
      )}
    </div>
  );
}
